import "./AllDocsNote.scss";
import { useSelector } from "react-redux";
import newRequest from "../../utils/newRequest";
import { useEffect, useState } from "react";
import { showToast } from "../../toastService";
import { useTranslation } from "react-i18next";
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";

// --- small helpers ---
const initials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() || "")
    .join("");


const AllDocsNote = ({ docId, docType, noteType }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [currentNote, setCurrentNote] = useState("");
  const [notes, setNotes] = useState([]);
  const [noteVisibility, setNoteVisibility] = useState("Public"); // Public | Internal
  const [isSaving, setIsSaving] = useState(false);


  const fetchNotes = async () => {
    try {
      const res = await newRequest.post("/allDocsNote/findAll", {
        note_docid: docId,
        note_type: noteType
      });
      // console.log(`fetchNotes  ${JSON.stringify(res.data, null, 2)}`);
      setNotes(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchNotes();
  }, [docId]);

  const addNote = async (e) => {
    // e.preventDefault();
    try {
      if (currentNote !== null && currentNote !== "") {

        const res = await newRequest.post("/allDocsNote/add", {
          note_doc_type: docType,
          note_docid: docId,
          note_text: currentNote,
          note_tags: [currentUser.usr_id],
          note_type: noteType
        });
        setCurrentNote("");
        if (res.data?.msg === "added") {
          console.log(`added  ${JSON.stringify(res.data, null, 2)}`);
          // add last
          // setNotes((prev) => [...prev, res.data?.doc]);
          // add first 
          setNotes((prev) => [res.data?.doc, ...prev]);
        } else {
          showToast("Error adding note!", "error");
        }

      } else {
        console.log("currentNote is null or empty");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const postComment = async () => {
    try {
      const body = String(currentNote || "").trim();
      if (!body) return;

      setIsSaving(true);
      const res = await newRequest.post("/allDocsNote/add", {
        note_doc_type: docType,
        note_docid: docId,
        note_text: currentNote,
        note_tags: [currentUser.usr_id],
        note_type: noteType,
        note_visibility: noteVisibility,
      });

      if (res?.data?.msg === "added") {
        setCurrentNote("");
        setNotes((prev) => [res.data?.doc, ...prev]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsSaving(false);
    }
  };


  return (
    <motion.div
      className="all-docs-note"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="doc-notes-wrapper">
          {/* Composer */}
          <div className="note-composer">
            <div className="note-avatar">
              {currentUser?.usr_photo_url ? (
                <img src={currentUser.usr_photo_url} alt="" className="note-avatar-img" />
              ) : (
                <span className="note-avatar-initials">{initials(currentUser?.usr_full_name || "Me")}</span>
              )}
            </div>

            <div className="note-composer-box">
              <textarea
                className="note-composer-input"
                placeholder="Type your message or internal note..."
                value={currentNote}
                onChange={(e) => setCurrentNote(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") postComment();
                }}
              />

              <div className="note-composer-actions">
                <div className="note-composer-left">
                  <button
                    type="button"
                    className={`note-toggle-pill ${noteVisibility === "Public" ? "active" : ""}`}
                    onClick={() => setNoteVisibility("Public")}
                  >
                    {t('public')}
                  </button>
                  <button
                    type="button"
                    className={`note-toggle-pill ${noteVisibility === "Internal" ? "active" : ""}`}
                    onClick={() => setNoteVisibility("Internal")}
                  >
                    {t('internal')}
                  </button>
                </div>

                <button
                  type="button"
                  className="note-send-btn"
                  onClick={postComment}
                  disabled={isSaving || !String(currentNote || "").trim()}
                >
                  {t('postComment')}
                </button>
              </div>
            </div>
          </div>
          <div className="notes-comments">
            {notes.map((c) => (
              <div className="note-comment" key={c.id}>
                <div className="note-avatar">
                  {c.created_by_photo_url_xx ? (
                    <img src={c.created_by_photo_url_xx} alt="" className="note-avatar-img" />
                  ) : (
                    <span className="note-avatar-initials">{initials(c.created_by_name_xx || "U")}</span>
                  )}
                </div>

                <div className="note-comment-right">
                  <div className="note-comment-top">
                    <div className="note-comment-name">
                      {c.created_by_name_xx || "User"}
                      {c.visibility === "Internal" && (
                        <span className="note-comment-badge">{t('internal')}</span>
                      )}
                    </div>
                    <div className="note-comment-time">{c?.time_ago_xx}</div>
                  </div>
                  <div className="note-comment-body">{c.note_text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </motion.div>
  )
}

export default AllDocsNote;
